export default {
  largestTitle: -1,
  largeTitle: -0.4,
  title: -0.2,
  smallTitle: 0,
  smallestTitle: 0,
  large: 0.2,
  default: 0,
  body: 0,
  small: 0.2,
  smallest: 0.2,
};
